import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ServiceArticleList } from 'src/app/models/settings/service-lists/service_article_list';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { FulltextService } from '../fulltext-service/fulltext.service';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class ServiceArticleListService extends OfflineDataService<ServiceArticleList> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService,
    public fulltextService: FulltextService,
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'ServiceArticleList',
      http,
      errorService,
      events,
      'service_article_lists/',
      'service_article_list',
      [
        'created_at',
        'updated_at',
        'created_by_id',
        'service_article_list_articles',
      ],
      [],
      'ean',
    );
  }
}
